import Alpine from "alpinejs";
import "share-api-polyfill"; // This polyfills navigator.share globally

export const webShare = {
  // Use simple existence check since the polyfill adds navigator.share
  canShare: !!navigator.share,
  url: "https://sringeri-panchangam.vercel.app",

  init() {},

  async sharePanchangam() {
    const preference = Alpine.store("userPreferences");
    const panchangam = Alpine.store("panchangam").panchangamData;
    const i18n = Alpine.store("i18n");

    if (!panchangam || !preference) return;

    const panchangamData = {
      date: panchangam.date,
      masa:
        preference.system === "chandramana"
          ? panchangam.masa
          : panchangam.saura_masa,
      paksha: panchangam.paksha,
      tithi: panchangam.tithi.tithi,
      nakshatra: panchangam.nakshatra.nakshatra,
      yoga: panchangam.yoga[0].yoga,
      karana: panchangam.karana[0].karana,
      samvatsara: panchangam.samvatsara,
      ritu: panchangam.ritu,
      ayana: panchangam.ayana,
    };

    // Correctly build the string using for...in on the data object
    let sharedText = "";
    for (const key in panchangamData) {
      // Assuming i18n.t(key) provides the translation for the label
      const label = i18n.t ? i18n.t[key] : key;
      sharedText += `${label} : ${panchangamData[key]}\n`;
    }

    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        // 1. Copy the text
        await navigator.clipboard.writeText(sharedText);
        console.log("Copied to clipboard.");

        // 2. TRIGGER NOTIFICATION IMMEDIATELY
        // Do this before the 'await' share call so it shows up right away
        Alpine.store("notification").show(
          i18n.t["copied_header"],
          i18n.t["copied_message"],
        );

        // 3. Open the share sheet
        // Code execution pauses here until the user closes the share window
        await navigator.share({
          title: `Panchangam for ${panchangamData.date}`,
          text: sharedText,
          url: this.url,
        });

        console.log("Successful share");
      }
    } catch (error) {
      if (error.name !== "AbortError") {
        console.error("Error sharing:", error);
      }
    }
  },
};
